export const API_URL = `https://www.ambitas.sk/en/api/v1`
export const TURNSTILE_SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || ''

export const FOOTER_ID = 'footer-section'

export const BREAKPOINTS = {
  desktop: 992,
}
